import { ArrowButton } from "@king-ict/eupisi-ui/components";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useHistory, useLocation } from "react-router";

import StaticField from "../../components/StaticField";
import { codebookRouteEducationSector } from '../../routes/routes';
import styles from "./RequestCodeBook.module.scss";

export default function CodeBookEducationSectorDetail(): JSX.Element {
  const history = useHistory();
  const location = useLocation();
  const { t } = useTranslation();

  const navigateToEducationSector = () => {
    history.push(
      codebookRouteEducationSector()
    );
  };

  return (
    <>
      <Row>
        <Col md={12}>
            <ArrowButton
              backwards
              ariaLabel=""
              onClick={navigateToEducationSector}
            />
            <span className={styles.backButtonCaption}>
              {t("codeBook.navigateToCodeBook")}
            </span>
          
        </Col>
      </Row>
      <Row className="mt-5">
        <Col md={8}>
          <h3>{t("codeBook.educationSector")}</h3>
        </Col>
        {/*<Col md={4} className="d-flex justify-content-end align-items-center">*/}
        {/*  <Button onClick={navigateToEditRecord} >*/}
        {/*    {t("common.edit")}*/}
        {/*  </Button>*/}
        {/*</Col>*/}
      </Row>
      <Row>
        <Col md={12} className="mt-5">
          <StaticField
            label={t("common.name")}
            value={(location.state as any).educationSector.name}
          />
        </Col>
      </Row>
    </>
  );
}